import { TitleWithDivider } from "@common/TitleWithDivider";
import CreateTenantForm from "@components/Forms/CreateTenantForm";
import pageHeaders from "@constants/PageHeaders";

const CreateTenantPage: React.FC = () => {
  return (
    <>
      <div>
        <TitleWithDivider
          titleText={pageHeaders.TENANT.add}
          useDivider={true}
        />
        <CreateTenantForm></CreateTenantForm>
      </div>
    </>
  );
};

export default CreateTenantPage;
